var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNursingStaffRegImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 120,
    viewBox: "0 0 95 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: -1,
    y: 1,
    width: 46.75,
    height: 58,
    rx: 23.375,
    transform: "matrix(-1 0 0 1 70.5 0)",
    fill: "white",
    stroke: "#2196F3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M72.5 28.75H65C60.1675 28.75 56.25 24.8325 56.25 20V18.75",
    stroke: "#2196F3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M25 28.75H47.5C52.3325 28.75 56.25 24.8325 56.25 20V10",
    stroke: "#2196F3",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    opacity: 0.2,
    d: "M72.3215 25.7144C72.3215 12.4595 61.5764 1.71436 48.3215 1.71436C35.0667 1.71436 24.3215 12.4595 24.3215 25.7144V29.1429H44.893C56.018 29.1429 57.268 22.5536 57.268 20.625V22.5C57.268 27.2339 62.4448 29.1429 67.1787 29.1429H72.3215V25.7144Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Subtract_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_22_567",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4062 65L46.875 80L62.3438 65H65.8214H75C86.0457 65 95 73.9543 95 85V120H0V85C0 73.9543 8.9543 65 20 65H23.75H31.4062Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4062 65L46.875 80L62.3438 65H65.8214H75C86.0457 65 95 73.9543 95 85V120H0V85C0 73.9543 8.9543 65 20 65H23.75H31.4062Z",
    fill: "#2196F3",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.875 80L45.4827 81.4358L46.875 82.7859L48.2673 81.4358L46.875 80ZM31.4062 65L32.7985 63.5642L32.2167 63H31.4062V65ZM62.3438 65V63H61.5333L60.9515 63.5642L62.3438 65ZM95 120V122H97V120H95ZM0 120H-2V122H0V120ZM48.2673 78.5642L32.7985 63.5642L30.014 66.4358L45.4827 81.4358L48.2673 78.5642ZM60.9515 63.5642L45.4827 78.5642L48.2673 81.4358L63.736 66.4358L60.9515 63.5642ZM62.3438 67H65.8214V63H62.3438V67ZM65.8214 67H75V63H65.8214V67ZM75 67C84.9411 67 93 75.0589 93 85H97C97 72.8497 87.1503 63 75 63V67ZM93 85V120H97V85H93ZM95 118H0V122H95V118ZM2 120V85H-2V120H2ZM2 85C2 75.0589 10.0589 67 20 67V63C7.84974 63 -2 72.8497 -2 85H2ZM20 67H23.75V63H20V67ZM23.75 67H31.4062V63H23.75V67Z",
    fill: "#2196F3",
    mask: "url(#path-5-inside-1_22_567)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M46.875 80.625V99.4821",
    stroke: "#2196F3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22",
    d: "M82.5 100V92.5C82.5 86.9772 78.0228 82.5 72.5 82.5V82.5C66.9772 82.5 62.5 86.9772 62.5 92.5V100",
    stroke: "#2196F3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 12",
    d: "M72.5 82.5V66.875",
    stroke: "#2196F3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M20 82.5V66.875",
    stroke: "#2196F3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 20,
    cy: 86.25,
    r: 4,
    fill: "white",
    stroke: "#2196F3",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNursingStaffRegImg);
export default __webpack_public_path__ + "static/media/nursingStaffRegImg.0871c7b7025be2bc8a9f9aa738c3d7cd.svg";
export { ForwardRef as ReactComponent };